<template>
    <video webkit-playsinline playsinline loop ref="videoDom" :style="styleObj">
        <source :src="videoUrl">
    </video>
</template>

<script setup>

import {computed, onMounted, ref} from "vue";

const props = defineProps(["videoUrl", "width", "height"])

const videoDom = ref(null)

const styleObj = computed(() => {
    const obj = {
        width: `${props.width}px`,
        height: `${props.height}px`
    }

    return obj
})

onMounted(() => {
    setTimeout(() => {
        videoDom.value.play()
    }, 500)
})

</script>

<style scoped>

</style>